module.exports = __webpack_public_path__ + "assets/img/chef-5.7dd50ad1.jpg";